import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M4.408 5.862l.821.875c1.063-.997 1.157-2.633.212-3.644-.512-.553-.446-1.394.152-1.955L4.771.263C3.696 1.272 3.603 2.874 4.562 3.91c.497.53.428 1.406-.154 1.952zm8 0l.821.875c1.063-.997 1.157-2.634.211-3.645-.512-.553-.446-1.394.152-1.955l-.821-.875c-1.076 1.01-1.168 2.611-.209 3.647.497.531.428 1.407-.154 1.953zm-4 0l.821.875c1.063-.997 1.157-2.634.211-3.645-.511-.552-.445-1.393.153-1.954L8.771.263C7.696 1.272 7.603 2.874 8.562 3.91c.497.53.428 1.406-.154 1.952zM0 8v1.001A9 9 0 0 0 9 18a9 9 0 0 0 9-8.999V8H0z" />
  </svg>
);

export default SvgComponent;
